import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Country, State, City } from "country-state-city";
import Swal from "sweetalert2";

function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    country: "IN",
    state: "",
    city: "",
    countryName: "India",
    phoneCode: "+91",   // ← hardcoded default, NOT using selectedCountry here
    phone: "",
    status: "Working Professional",
    course: "AI / Machine Learning (Live)",
    experience: "No prior experience",
    message: "",
  });

  const countries = Country.getAllCountries();
  const states = State.getStatesOfCountry(form.country);
  const cities = City.getCitiesOfState(form.country, form.state);

  // HANDLE CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      const selected = countries.find((c) => c.isoCode === value);
      setForm((prev) => ({
        ...prev,
        country: value,
        countryName: selected?.name || "",
        phoneCode: "+" + (selected?.phonecode || "91"),
        state: "",
        city: "",
      }));
      return;
    }

    if (name === "state") {
      setForm((prev) => ({ ...prev, state: value, city: "" }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://swiftintelli.com/api/saveContact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const text = await res.text();
      console.log("SERVER RESPONSE:", text);
      const data = JSON.parse(text);

      if (data.status === "success") {
        await fetch("https://swiftintelli.com/api/sendContactMail.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });

        setSubmitted(true);
        setForm({
          name: "",
          email: "",
          country: "IN",
          state: "",
          city: "",
          countryName: "India",
          phoneCode: "+91",
          phone: "",
          status: "Working Professional",
          course: "AI / Machine Learning (Live)",
          experience: "No prior experience",
          message: "",
        });

        Swal.fire({
          icon: "success",
          title: "Message Sent! 🎉",
          text: "We've received your message and will get back to you shortly.",
          confirmButtonColor: "#2563eb",
          confirmButtonText: "Great, Thanks!",
          allowOutsideClick: false,
        }).then(() => setSubmitted(false));

      } else if (data.status === "exists") {
        Swal.fire({
          icon: "info",
          title: "Already Contacted",
          text: "We already have your inquiry. Our team will reach out to you soon!",
          confirmButtonColor: "#2563eb",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong. Please try again.",
          confirmButtonColor: "#2563eb",
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Could not connect to server. Please try again later.",
        confirmButtonColor: "#2563eb",
      });
    }

    setLoading(false);
  };

  return (
    <>
      <Navbar />

      <div className="contact-page">

        {/* HERO */}
        <section className="contact-hero">
          <h1>Contact SwiftIntelli</h1>
          <p>
            We're here to help you with courses, collaborations,
            mentorship, and technical guidance.
          </p>
        </section>

        {/* CONTACT SECTION */}
        <section className="si-section si-contact" id="contact">
          <div className="si-contact-grid">

            {/* LEFT SIDE */}
            <div className="si-contact-left">

              <div className="si-section-label">Get in touch</div>
              <h2 className="si-h2">
                Let's <span style={{ color: "var(--accent2, #2563eb)" }}>Connect</span>
              </h2>
              <p className="si-section-intro">
                Ready to start your journey? Have questions? We're here
                to help you find the right program.
              </p>

              {/* INFO ITEMS */}
              {[
                ["📧", "Email",    "contact@swiftintelli.com"],
                ["📞", "Phone",    "+91 9391966251"],
                ["📍", "Location", "Hyderabad, India (Online Batches Available)"],
              ].map(([icon, label, val]) => (
                <div key={label} className="si-contact-info-item">
                  <div className="si-contact-icon">{icon}</div>
                  <div>
                    <div className="si-contact-label">{label}</div>
                    <div className="si-contact-value">{val}</div>
                  </div>
                </div>
              ))}

              {/* BATCH BOX */}
              <div className="si-batch-box">
                <h3>Join the next batch</h3>
                <p>
                  AI/ML Batch 2026 is now open. Everyday, IST-friendly
                  timings, fully live instruction with recordings available.
                </p>
                <div className="si-seats">
                  <div className="si-seats-dot" />
                  <span>Seats filling fast</span>
                </div>
              </div>

            </div>

            {/* RIGHT SIDE — FORM CARD */}
            {/* RIGHT SIDE — FORM CARD */}
<div className="si-contact-form-card">

  <form onSubmit={handleSubmit}>

    {/* NAME + EMAIL */}
    <div className="si-form-group si-form-row">

      <div>
        <label className="si-label">
          Full Name
        </label>

        <input
          name="name"
          className="si-input"
          placeholder="Your name"
          value={form.name}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label className="si-label">
          Email Address
        </label>

        <input
          name="email"
          className="si-input"
          type="email"
          placeholder="you@email.com"
          value={form.email}
          onChange={handleChange}
          required
        />
      </div>

    </div>

    {/* COUNTRY + PHONE */}
    <div className="si-form-group si-form-row">

      <div>
        <label className="si-label">
          Country
        </label>

        <select
          name="country"
          className="si-select"
          value={form.country}
          onChange={handleChange}
        >
          {countries.map((c) => (
            <option
              key={c.isoCode}
              value={c.isoCode}
            >
              {c.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="si-label">
          Phone Number
        </label>

        <div className="si-phone-row">

          <input
            className="si-input si-phone-code"
            value={form.phoneCode}
            readOnly
          />

          <input
            name="phone"
            className="si-input"
            type="tel"
            placeholder="Phone Number"
            value={form.phone}
            onChange={handleChange}
            required
          />

        </div>
      </div>

    </div>

    {/* STATE + CITY */}
    <div className="si-form-group si-form-row">

      <div>
        <label className="si-label">
          State
        </label>

        <select
          name="state"
          className="si-select"
          value={form.state}
          onChange={handleChange}
          required
        >
          <option value="">
            Select State
          </option>

          {states.map((s) => (
            <option
              key={s.isoCode}
              value={s.isoCode}
            >
              {s.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="si-label">
          City
        </label>

        <select
          name="city"
          className="si-select"
          value={form.city}
          onChange={handleChange}
          required
        >
          <option value="">
            Select City
          </option>

          {cities.map((c) => (
            <option
              key={c.name}
              value={c.name}
            >
              {c.name}
            </option>
          ))}
        </select>
      </div>

    </div>

    {/* STATUS + EXPERIENCE */}
    <div className="si-form-group si-form-row">

      <div>
        <label className="si-label">
          Current Status
        </label>

        <select
          name="status"
          className="si-select"
          value={form.status}
          onChange={handleChange}
        >
          {[
            "Working Professional",
            "Student",
            "Fresher",
            "Self Employed",
          ].map((o) => (
            <option key={o}>
              {o}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="si-label">
          Programming Experience
        </label>

        <select
          name="experience"
          className="si-select"
          value={form.experience}
          onChange={handleChange}
        >
          {[
            "No prior experience",
            "Beginner (basics only)",
            "Intermediate",
            "Advanced",
          ].map((o) => (
            <option key={o}>
              {o}
            </option>
          ))}
        </select>
      </div>

    </div>

    {/* COURSE */}
    <div className="si-form-group">

      <label className="si-label">
        Interested Course
      </label>

      <select
        name="course"
        className="si-select"
        value={form.course}
        onChange={handleChange}
      >
        {[
          "AI / Machine Learning (Live)",
          "IoT & Embedded Systems (Upcoming)",
          "Robotics (Upcoming)",
          "Prompt Engineering (Upcoming)",
          "Not Sure — Help Me Decide",
        ].map((o) => (
          <option key={o}>
            {o}
          </option>
        ))}
      </select>

    </div>

    {/* MESSAGE */}
    <div className="si-form-group">

      <label className="si-label">
        Message (Optional)
      </label>

      <textarea
        name="message"
        className="si-textarea"
        placeholder="Tell us your goals or any questions..."
        value={form.message}
        onChange={handleChange}
      />

    </div>

    {/* SUBMIT */}
    <button
      type="submit"
      className="si-submit-btn"
      disabled={loading}
    >
      {loading
        ? "Submitting..."
        : submitted
        ? "Message Sent 🎉"
        : "Submit Application →"}
    </button>

  </form>

</div>

          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default Contact;